import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Input from "../input/Input";
import { addFeedback } from "../../Services/ApiService";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const Evaluation = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {
  const [registerModal, setRegisterModal] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeTabHeader, setActiveTabHeader] = React.useState("Evaluation");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const [form, setForm] = useState({
    name: "",
    email: "",
    role: "",
    gender: "",
    message: "",
  });

  const [studTeacher, setStudTeacher] = useState("");
  const [gender, setGender] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert("Form submitted!\n" + JSON.stringify(form, null, 2));
  //   // Replace with actual submission logic
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload

    try {
      let body = {
        name: form.name,
        userType: form.role,
        email: form.email,
        gender: form.gender,
        message: form.message,
      };

      const response = await addFeedback(body);

      if (response.success) {
        toast.success(response.message);

        // ✅ clear state after success
        setForm({
          name: "",
          email: "",
          role: "",
          gender: "",
          message: "",
        });
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log(error, "e");
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        AdminregisterModal={AdminregisterModal}
        setAdminregisterModal={setAdminregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
        allCountries={allCountries}
      />
      <div>
        <div className="feedBackBanner">
          <div className="bannerOverlayFF">
            <div className="f1">
              {lang === "en"
                ? "YOUR FEEDBACK MATTERS THE MOST"
                : lang === "hi"
                  ? "आपकी फीडबैक सबसे महत्वपूर्ण है"
                  : null}
            </div>
            <div className="f2">
              {lang === "en"
                ? "The evaluation of NCERT KATBOOK's is an important step in enhancing the quality and effectiveness of digital learning resources."
                : lang === "hi"
                  ? "एनसीईआरटी कैटबुक्स का मूल्यांकन डिजिटल शिक्षण संसाधनों की गुणवत्ता और प्रभावशीलता को बढ़ाने में एक महत्वपूर्ण कदम है।"
                  : null}
            </div>
            <div className="f2">
              {lang === "en"
                ? "Your feedback will provide valuable insights on usability, relevance, and impact in actual teaching–learning environments."
                : lang === "hi"
                  ? "आपकी फीडबैक वास्तविक शिक्षण-अधिगम वातावरण में प्रयोज्य, प्रासंगिकता और प्रभाव के बारे में बहुमूल्य जानकारी प्रदान करेगी।"
                  : null}
            </div>
          </div>
        </div>

        <div className="f3">
          {lang === "en"
            ? "Every response will contribute towards refining the KATBOOK's to better serve the needs of students and teachers across the country."
            : lang === "hi"
              ? "प्रत्येक प्रतिक्रिया देश भर के छात्रों और शिक्षकों की आवश्यकताओं को बेहतर ढंग से पूरा करने के लिए KATBOOK's को परिष्कृत करने में योगदान देगी।"
              : null}
        </div>

        <div className="containerF">
          <div className="title">
            {lang === "en"
              ? "Start a Conversation"
              : lang === "hi"
                ? "बातचीत शुरू करें"
                : null}
          </div>
          <div className="subtitle">
            {lang === "en"
              ? "Your Journey to Educational Excellence Begins with Us"
              : lang === "hi"
                ? "शैक्षणिक उत्कृष्टता की आपकी यात्रा हमसे शुरू होती है"
                : null}
          </div>
          <form>
            <div className="formGrid">
              <div className="formColumn">
                <label className="labels">
                  {lang === "en"
                    ? "Name"
                    : lang === "hi"
                      ? "नाम"
                      : null}
                  <input
                    className="input"
                    name="name"
                    placeholder={lang === "en"
                      ? "Enter Your Name"
                      : lang === "hi"
                        ? "अपना नाम दर्ज करें"
                        : null}
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </label>
                <label className="labels">
                  <div className="d-flex flex-column">
                    <label className="labels">
                      {lang === "en"
                        ? "Are you a Teacher or Student ?"
                        : lang === "hi"
                          ? "क्या आप शिक्षक या छात्र हैं ?"
                          : null}
                    </label>
                    <select
                      className="input"
                      name="role"
                      value={form.role}
                      onChange={handleChange}
                      disabled={!form.email}
                    >
                      <option value="" disabled selected>
                        {lang === "en"
                          ? "Select a Teacher or Student"
                          : lang === "hi"
                            ? "शिक्षक या छात्र का चयन करें"
                            : null}
                      </option>
                      <option value="teacher">
                        {lang === "en"
                          ? "Teacher"
                          : lang === "hi"
                            ? "अध्यापक"
                            : null}
                      </option>
                      <option value="student">
                        {lang === "en"
                          ? "Student"
                          : lang === "hi"
                            ? "विद्यार्थी"
                            : null}
                      </option>
                    </select>
                  </div>
                </label>
              </div>
              <div className="formColumn">
                <label className="labels">
                  {lang === "en"
                    ? "Email ID"
                    : lang === "hi"
                      ? "ईमेल आईडी"
                      : null}
                  <input
                    className="input"
                    type="email"
                    name="email"
                    placeholder={lang === "en"
                      ? "Enter your mail id"
                      : lang === "hi"
                        ? "अपना ईमेल आईडी दर्ज करें"
                        : null}
                    value={form.email}
                    onChange={handleChange}
                    required
                    disabled={!form.name}
                  />
                </label>
                <label className="labels">
                  <div className="d-flex flex-column">
                    <label className="labels">
                      {lang === "en"
                        ? "Gender"
                        : lang === "hi"
                          ? "लिंग"
                          : null}
                    </label>
                    <select
                      className="input"
                      value={form.gender}
                      name="gender"
                      onChange={handleChange}
                      disabled={!form.role}
                    >
                      <option value="" disabled selected>
                        {lang === "en"
                          ? "Select Gender"
                          : lang === "hi"
                            ? "लिंग चुनें"
                            : null}
                      </option>
                      <option value="male">
                        {lang === "en"
                          ? "Male"
                          : lang === "hi"
                            ? "पुरुष"
                            : null}
                      </option>
                      <option value="female">
                        {lang === "en"
                          ? "Female"
                          : lang === "hi"
                            ? "महिला"
                            : null}
                      </option>
                      <option value="others">
                        {lang === "en"
                          ? "Others"
                          : lang === "hi"
                            ? "अन्य"
                            : null}
                      </option>
                    </select>
                  </div>
                </label>
              </div>
            </div>
            <label className="labels textareawid">
              {lang === "en"
                ? "Write your Message here"
                : lang === "hi"
                  ? "अपना संदेश यहाँ लिखें"
                  : null}
              <textarea
                className="textarea"
                name="message"
                placeholder={lang === "en"
                  ? "Tell us more..."
                  : lang === "hi"
                    ? "हमें और अधिक बताएँ..."
                    : null}
                value={form.message}
                onChange={handleChange}
                required
                disabled={!form.gender}
              />
            </label>
            <div className="buttonWrap">
              <button
                style={{ cursor: !form.message ? "no-drop" : "pointer" }}
                disabled={!form.message}
                onClick={handleSubmit}
                type="submit"
                className="button"
              >
                {lang === "en" ? (
                  <>
                    Submit Response &nbsp; &rarr;
                  </>
                ) : lang === "hi" ? (
                  <>
                    प्रतिक्रिया सबमिट करें &nbsp; &rarr;
                  </>
                ) : null}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
      />
    </div>
  );
};

export default Evaluation;
